import React, { Component } from 'react'
import { connect } from 'react-redux'
import '../../App.css'
import './style.css'
import {
  Grid, TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import isEmpty from 'lodash.isempty';
import { GetActivities, EditActivity, CreateNewActivity, DeleteActivity } from './ProjectsAction';

const tableHeader = ['Aktion', 'Stichwort', "Tätigkeit", "Kürzel"]

class Activity extends Component {

  constructor(props) {
    super(props);
    this.state = {
      propsProjectData: this.props.project_data,
      projectActivities: [],
      activityID: '',
      deleteDialog: false,
      editMode: false,
      error: '',
      activityDialog: false,
      activityField: '',
      abbrivationField: '',
      keywordField: '',
    }
  }


  componentDidMount = () => {
    const { propsProjectData } = this.state
    this.props.GetActivities(propsProjectData.id)
  }


  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { project_activities, error_validation } = this.props
    if (nextProps.project_activities !== project_activities) {
      this.setState({
        projectActivities: nextProps.project_activities,
        activityDialog: false
      })
    }
    if (nextProps.error_validation !== error_validation) {
      this.setState({ error: nextProps.error_validation })
    }
  }

  renderTableHeader = () => {
    return tableHeader.map((val, index) => {
      return <TableCell key={index} >{val}</TableCell>
    })
  }

  getInvoiceData = (activity) => {
    this.setState({
      activityID: activity.id,
      keywordField: activity.keyword,
      abbrivationField: activity.token,
      activityField: activity.activity,
      activityDialog: true,
      editMode: true
    })
  }


  tableFields = () => {
    const { projectActivities } = this.state
    if (!isEmpty(projectActivities)) {
      return projectActivities.map((activity, index) =>
        <TableRow key={index}>
          <TableCell>
            <EditIcon onClick={() => this.getInvoiceData(activity)} />
            <DeleteIcon onClick={() => this.setState({ deleteDialog: true, activityID: activity.id })} />
          </TableCell>
          <TableCell >
            {activity.keyword}
          </TableCell>
          <TableCell >
            {activity.activity}
          </TableCell>
          <TableCell>
            {activity.token}
          </TableCell>
        </TableRow>
      )
    }
  }

  createActivity = () => {
    const dataObj = this.state
    this.props.CreateNewActivity(dataObj)
  }
  editActivity = () => {
    const dataObj = this.state
    this.props.EditActivity(dataObj)
  }

  deleteActivity = () => {
    const { propsProjectData, activityID } = this.state
    this.props.DeleteActivity(propsProjectData.id, activityID)
    this.setState({ deleteDialog: false })
  }


  render() {
    const {
      editMode,
      activityDialog,
      deleteDialog,
      error,
      keywordField,
      abbrivationField,
      activityField
    } = this.state
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const { forOther, forOwn } = this.props
    return (
      <div>
        <div
          className={`capacityTable tableActivity tableStyle ${(Number(access_rights.projects_activity_for_other) !== 2 && forOther) || (Number(access_rights.projects_activity_for_own) !== 2 && !forOwn && !forOther) || (Number(access_rights.projects_activity_for_own) !== 2 && forOwn) ? "disableALlFields" : ""}`}
        >
          <Grid container spacing={1}>
            {!((Number(access_rights.projects_activity_for_other) !== 2 && forOther) || (Number(access_rights.projects_activity_for_own) !== 2 && forOwn)) &&
              <div className="action-top-btn">
                <Button variant="outlined" color="primary" onClick={() => this.setState({
                  activityDialog: true,
                  keywordField: '',
                  abbrivationField: '',
                  activityField: '',
                  editMode: false
                })}>Tätigkeit hinzufügen</Button>
              </div>
            }
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {this.renderTableHeader()}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.tableFields()}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          <Dialog
            open={activityDialog}
            maxWidth="md"
            className="modal-new-in"
          >
            {editMode ?
              <DialogTitle>Tätigkeit bearbeiten</DialogTitle>
              :
              <DialogTitle>Tätigkeit hinzufügen</DialogTitle>
            }
            <DialogContent>
              <DialogContentText >

                <Grid container spacing={1}>
                  <Grid item xs={6} style={{ paddingTop: '30px' }}>
                    <Grid container spacing={1}>
                      <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px' }}>Stichwort</Grid>
                      <Grid item xs={9}>
                        <TextField fullWidth
                          value={keywordField}
                          helperText={!isEmpty(error.keyword) ? error.keyword : ''} error={!isEmpty(error.keyword) ? true : false}
                          variant="outlined"
                          inputProps={{ maxLength: 40 }}
                          onChange={(e) => {
                            if (!isEmpty(error.keyword))
                              error.keyword = []
                            this.setState({ keywordField: e.target.value })
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px' }}>Kürzel</Grid>
                      <Grid item xs={9}>
                        <TextField fullWidth
                          value={abbrivationField}
                          inputProps={{ maxLength: 6 }}
                          helperText={!isEmpty(error.token) ? error.token : ''} error={!isEmpty(error.token) ? true : false}
                          variant="outlined"
                          onChange={(e) => {
                            if (!isEmpty(error.token))
                              error.token = []
                            this.setState({ abbrivationField: e.target.value })
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} style={{ paddingTop: '0px', fontSize: '14px' }}>Tätigkeit</Grid>
                      <Grid item xs={12} className="d-flex textarea-field textarea-field-2">
                        <TextField fullWidth multiline rows={5}
                          helperText={!isEmpty(error.activity) ? error.activity : ''} error={!isEmpty(error.activity) ? true : false}
                          value={activityField}
                          variant="outlined"
                          onChange={(e) => {
                            if (!isEmpty(error.activity))
                              error.activity = []
                            this.setState({ activityField: e.target.value })
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

              </DialogContentText>
            </DialogContent>
            <DialogActions>
              {!editMode ?
                <Button size="small" variant="outlined" color="primary" onClick={this.createActivity}>
                  Hinzufügen
              </Button>
                :
                <Button size="small" variant="outlined" color="primary" onClick={this.editActivity}>
                  Speichern
              </Button>
              }
              <Button onClick={() => this.setState({ activityDialog: false, error: '' })} size="small" variant="outlined" color="secondary">
                Abbrechen
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={deleteDialog}
          >
            <DialogTitle>Tätigkeit löschen</DialogTitle>
            <DialogContent>
              <DialogContentText >
                Sind Sie sicher?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.deleteActivity} size="small" variant="outlined" color="primary" >
                Bestätigen
              </Button>
              <Button onClick={() => this.setState({ deleteDialog: false })} size="small" variant="outlined" color="secondary">
                Abbrechen
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div >
    )
  }
}

const mapStateToProps = ({ projectsData, systems }) => {
  return {
    project_activities: projectsData.project_activities,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    GetActivities: (id) => dispatch(GetActivities(id)),
    CreateNewActivity: (data) => dispatch(CreateNewActivity(data)),
    EditActivity: (data) => dispatch(EditActivity(data)),
    DeleteActivity: (id, activityID) => dispatch(DeleteActivity(id, activityID)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Activity)
